export const slideWidth = '23vw'
export const slideEdgePadding = '15.5vw'


// WEBPACK FOOTER //
// ./src/Components/Theme/Omaha/OmahaConstants.js